<template>
  <div class="template">
    <q-form
      class="q-px-xl"
      ref="loginForm"
      @submit.prevent.stop="onSubmit"
    >
      <div class="group-input col-12 row q-mt-sm">
        <label for="os_userName">Nome do usuario</label>
        <q-input
          id="os_userName"
          ref="osUserNameRef"
          type="text"
          class="col-12 q-mt-sm"
          bg-color="white"
          maxlength="100"
          color="red-9"
          dense
          outlined
          unmasked-value
          v-model="auth.name"
          :rules="[(val) => !!val.length || 'Campo Obrigatório']"
          lazy-rules
        />
      </div>

      <div class="group-input col-12 row q-mt-sm">
        <label for="os_number">Telefone (DDD) + número</label>
        <q-input
          id="os_number"
          ref="osNumberRef"
          type="text"
          class="col-12 q-mt-sm"
          bg-color="white"
          maxlength="15"
          color="red-9"
          dense
          outlined
          mask="(##) #####-####"
          unmasked-value
          v-model="auth.phone"
          :rules="[(val) => !!val.length || 'Campo Obrigatório']"
          lazy-rules
        />
      </div>

      <div class="group-input col-12 row q-mt-sm">
        <label for="os_number">Usuário</label>
        <q-input
          id="os_number"
          ref="osNumberRef"
          type="text"
          class="col-12 q-mt-sm"
          bg-color="white"
          maxlength="30"
          color="red-9"
          dense
          outlined
          unmasked-value
          v-model="auth.userName"
          :rules="[(val) => !!val.length || 'Campo Obrigatório']"
          lazy-rules
        />
      </div>

      <div class="submit-btn col-12 row q-mt-sm">
        <label for="os_number">Credenciada</label>
        <q-select
          id="type-os"
          class="col-12 q-mt-sm form-tabulacao"
          outlined
          dense
          ref="redoDropRef"
          v-model="auth.accredited"
          color="red-9"
          option-value="value"
          option-label="text"
          map-options
          emit-value
          fill-input
          use-input
          :options="accreditedsFilteded"
          @filter="filterFn"
          bg-color="white"
          :rules="[(val) => val.length || 'Campo Obrigatório']"
          lazy-rules
        />
      </div>

      <div class="group-input col-12 row q-mt-sm">
        <label for="os_number">Senha</label>
        <q-input
          id="form_password"
          ref="osPasswordRef"
          :type="isPwd ? 'password' : 'text'"
          class="col-12 q-mt-sm"
          bg-color="white"
          maxlength="12"
          color="red-9"
          dense
          outlined
          unmasked-value
          v-model="auth.password"
          :rules="[(val) => !!val.length || 'Campo Obrigatório']"
          lazy-rules
        >
          <template v-slot:append>
            <q-icon
              size="18px"
              :name="isPwd ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"
              class="cursor-pointer"
              @click="isPwd = !isPwd"
            />
          </template>
        </q-input>
      </div>

      <div class="submit-btn col-12 row q-mt-sm">
        <div class="submit-btn col-md-12 flex justify-end section-btn">
          <q-btn
            class="submit-btn"
            unelevated
            no-caps
            :loading="btnLoading"
            size="md"
            type="submit"
            label="Cadastro"
            rounded
            color="red-9"
          />
        </div>
      </div>
    </q-form>
  </div>
</template>

<script>
  //-----VUEJS
  import { onMounted, ref } from "vue";

  //-----QUASAR
  import router from "@/router";
import ContingencyServices from "@/services/ContingencyServices";
import LowProductionServices from "@/services/LowProductionServices";
import { useQuasar } from "quasar";

  export default {
    name: "AddUser",

    setup() {
      //----CONSTANTS
      const loginForm = ref(null);

      const contingencyServices = new ContingencyServices();
      const lowProductionServices = new LowProductionServices();
      const $q = useQuasar();

      //----VARIABLES
      let auth = ref({
        profile: "",
        phone: "",
        userName: "",
        name: "",
        password: "",
        accredited: "",
      });
      let btnLoading = ref(false);
      let isPwd = ref(true);
      let accrediteds = ref([]);
      let accreditedsFilteded = ref([]);

      //FUNCTIONS
      function filterFn(val, update) {
        if (val === "") {
          update(() => {
            accreditedsFilteded.value = accrediteds.value;

            // here you have access to "ref" which
            // is the Vue reference of the QSelect
          });
          return;
        }

        update(() => {
          const needle = val.toLowerCase();
          accreditedsFilteded.value = accrediteds.value.filter(
            (v) => v.text.toLowerCase().indexOf(needle) > -1
          );
        });
      }

      async function onSubmit() {
        if (!(await loginForm.value.validate())) {
          $q.notify({
            color: "red-5",
            message: "Você precisa preencher todos os campos obrigatórios",
          });
          return;
        }
        btnLoading.value = true;

        let data = {
          usuario: auth.value.userName,
          nome: auth.value.name,
          senha: auth.value.password,
          telefone: auth.value.phone,
          credenciada: auth.value.accredited,
        };

        await contingencyServices
          .registerUser(data)
          .then((response) => {
            $q.notify({
              message: "Cadastro realizado com sucesso",
              color: "green-9",
              position: "top",
            });
            router.push({ name: "login" });
          })
          .catch((error) => {
            console.log(error);
            $q.notify({
              message: "Erro ao registrar usuario",
              color: "red-9",
              position: "top",
            });
            btnLoading.value = false;
          });
      }

      async function getAccrediteds() {
        await lowProductionServices
          .getAccreditedsContingency()
          .then((success) => {
            accrediteds.value = success.map((item) => {
              return {
                value: item.codcredenciada,
                text: item.credenciada,
              };
            });
          })
          .catch((err) => {
            console.log(err);
          });
      }

      onMounted(() => {
        getAccrediteds();
      });

      return {
        //----VARIABLES
        loginForm,
        auth,
        btnLoading,
        isPwd,
        accreditedsFilteded,

        //FUNCTIONS
        onSubmit,
        filterFn,
      };
    },
  };
</script>
<style lang="scss" scoped>
  .template {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: #e5e5e5;

    label {
      color: rgba(0, 0, 0, 0.4);
      font-size: 0.875rem;
      font-family: Roboto;
      font-weight: 700;
    }
  }

  .submit-btn {
    width: 100%;
    display: flex;
  }
</style>
